<template>
  <div class="zsy-logo-div2">
    <!-- <van-image src="http://file.wisewater.cn/group1/M01/0E/E0/rBAABWBvtG-AemFJAAA6VYqnBsw007.png" /> -->
    <div class="zsy-version" v-if="token !== 'fceb81089b6f419aa62f5e0b82e33efe'">智水云微信营业厅&nbsp;Version&nbsp;2.0</div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Image as VanImage } from 'vant'

Vue.use(VanImage)
export default {
  name: 'app-footer',
  props: {
    token: String
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
  .zsy-logo-div2 {
    position: relative;
    width: 100%;
    margin: 10px 0 60px 0;
    margin-bottom: calc(60px + constant(safe-area-inset-bottom));
    margin-bottom: calc(60px + env(safe-area-inset-bottom));
    text-align: center;
  }
  .van-image {
    width: 75px;
    height: 25px;
    margin-top: 5px;
  }
  .zsy-version {
    color: #999;
    font-size: 14px;
    line-height: 1.6;
  }
</style>
